import Grid from '@material-ui/core/Grid';
import {Card, Form, Select, Col, Row, message} from 'antd';
import Collapse, { Panel } from '@components/ui/Collapse';
import styles from './NewOrder.module.scss';
import React, { useEffect, useState} from 'react';
import {getChainsForUser} from "@components/UserManagement/helper";
import {LocalPersistence} from "@factories/Mutations";
import {getAllHotelCodes, languages, languageType} from "@ui/auditReport";


type OptionType = {
  value: string;
  label: string;
};
interface NewOrderProps {
  validateFields: (value: boolean) => void;
  formData: any;
}
const NewOrder = (props: NewOrderProps) => {
  const { Option } = Select;
  const [showOnly, setShowOnly] = useState<boolean>(false);
  const [userChains, setUserChains] = useState<string[]>([]);

  const [optionTypes, setOptionTypes] = useState<OptionType[]>()

  const onChangeItem = async (value:string) => {

    getAllHotelCodes(value).then((res) => {
      if(res.result.success){
        const optionTypes: OptionType[] | undefined = res.hotelCodes?.map(
            (hotel: string): OptionType =>({
              label:hotel,
              value:hotel
            }));
        setOptionTypes(optionTypes);
      }
    })
  }

  const apiGetUserChainValues = async () => {
    try{
        const get_session = new LocalPersistence('session');
        const session = await get_session.getSessionPersistence();

        const { user }: any = await getChainsForUser({ id: session.userId });

        const selectedChains: string[] = user.chains.map(
          ({ chainName }: { chainName: string }) => chainName
        );
        if(selectedChains.length < 1){
          setUserChains(["MGM", "OMNI"])
        }else{
          setUserChains(selectedChains);
        }
    } catch (err: any) {
      message.error({
        content: err.message || err.error[0].message
      });
    }


  }
  useEffect(()=>{
    apiGetUserChainValues();
  },[])


  // @ts-ignore
  return (
    <Card>
      <Grid
        item
        xs={12}
        className="p-0"
      >
        <Form
          layout="vertical"
          form={props.formData}
          name="basic"
          onValuesChange={props.validateFields}
        >
          <Collapse defaultActiveKey={['1']}>
            <Panel
              header="New Content Audit Report"
              key="1"
            >
              <Grid
                container
                spacing={3}
              >
                <Row
                  gutter={24}
                  className={styles.options}
                >
                  <Col span={16}>
                    <Form.Item
                      label="Choose a Supplier Hotel Group"
                      name="supplier"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Select allowClear onChange={onChangeItem}
                        showSearch>
                        {
                          userChains.map((chain: string, index:number) => (
                            <Option value={chain} key={index}> {chain}</Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={16}>
                    <Form.Item
                      label="Choose the Descriptive Content Language"
                      name="contentLanguage"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Select allowClear // onChange={onChangeItem}
                        showSearch>
                        {
                          languages.map((value: languageType, index: number) =>(
                              <Option value={value.key} key={index}> {value.label}</Option>
                          ))
                        }
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={16}>
                    <Form.Item
                      label="Choose Hotels"
                      name="hotels"
                      rules={[]}
                    >
                      <Select
                        allowClear
                        onChange={(e) => setShowOnly(e === 'ids')}
                        showSearch
                      >
                        <Option value="all">
                          All Hotels of the Selected Chain
                        </Option>
                        <Option value="ids">
                          Enter property IDs for select properties within the
                          chain
                        </Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  {showOnly && (
                    <Col span={16}>
                      <Form.Item
                        label="Only the Following Properties are Needed"
                        name="only"
                        rules={[
                          {
                            required: true,
                          },
                        ]}                      >
                        <Select allowClear mode="multiple"
                            style={{ width: '100%' }}
                            placeholder="Please select"
                            defaultValue={[]}
                            //onChange={handleChange}
                            options={optionTypes} />
                      </Form.Item>
                    </Col>
                  )}
                </Row>
              </Grid>
            </Panel>
          </Collapse>
        </Form>
      </Grid>
    </Card>
  );
};

export default NewOrder;
